import {
  BaseFormData,
  DeleteObject,
  FormState,
  FormStateType,
} from "./incident.type";

// Action types
const UPDATE_BASE_FORM_DATA = "UPDATE_BASE_FORM_DATA";
const UPDATE_INCIDENT_FORM_DATA = "UPDATE_INCIDENT_FORM_DATA";
const UPDATE_FORM_STATE = "UPDATE_FORM_STATE";
const MERGE_TAB_STATE = "MERGE_TAB_STATE";
const UPDATE_DELETE_RL_RECORD = "UPDATE_DELETE_RL_RECORD";
const RESET_DELETE_RL_RECORD = "RESET_DELETE_RL_RECORD";

// Action interfaces
interface UpdateBaseFormDataAction {
  type: typeof UPDATE_BASE_FORM_DATA;
  payload: Partial<BaseFormData>;
}

interface UpdateIncidentFormDataAction {
  type: typeof UPDATE_INCIDENT_FORM_DATA;
  payload: { [key: string]: any };
}

interface UpdateFormStateAction {
  type: typeof UPDATE_FORM_STATE;
  payload: Partial<FormState>;
}

type TabStatePatch = {
  [K in keyof FormState["tabState"]]?: Partial<FormState["tabState"][K]>;
};

interface MergeTabStateAction {
  type: typeof MERGE_TAB_STATE;
  payload: TabStatePatch;
}

interface UpdateDeleteRLRecordAction {
  type: typeof UPDATE_DELETE_RL_RECORD;
  payload: DeleteObject;
}

interface ResetDeleteRLRecordAction {
  type: typeof RESET_DELETE_RL_RECORD;
}

export type FormAction =
  | UpdateBaseFormDataAction
  | UpdateIncidentFormDataAction
  | UpdateDeleteRLRecordAction
  | ResetDeleteRLRecordAction
  | UpdateFormStateAction
  | MergeTabStateAction;

export function formReducer(
  state: FormStateType,
  action: FormAction
): FormStateType {
  switch (action.type) {
    case UPDATE_BASE_FORM_DATA:
      return {
        ...state,
        baseFormData: { ...state.baseFormData, ...action.payload },
      };
    case UPDATE_INCIDENT_FORM_DATA:
      return {
        ...state,
        incidentFormData: { ...state.incidentFormData, ...action.payload },
      };
    case UPDATE_DELETE_RL_RECORD: {
      let finalPayload = [...state.deleteRelatedRecords];
      if (Array.isArray(action.payload)) {
        finalPayload = [...finalPayload, ...action.payload];
      } else {
        finalPayload = [...finalPayload, action.payload];
      }
      return {
        ...state,
        deleteRelatedRecords: [...finalPayload],
      };
    }
    case RESET_DELETE_RL_RECORD:
      return {
        ...state,
        deleteRelatedRecords: [],
      };
    case UPDATE_FORM_STATE:
      return {
        ...state,
        formState: { ...state.formState, ...action.payload },
      };
    case MERGE_TAB_STATE: {
      // Merge per tab into the LATEST tabState so concurrent single-tab writers
      // (active-tab vs whole-form revalidation) compose instead of clobbering.
      const current = (state.formState.tabState ?? {}) as Record<string, any>;
      const merged = { ...current };
      Object.entries(action.payload).forEach(([tab, patch]) => {
        merged[tab] = { ...current[tab], ...patch };
      });
      return {
        ...state,
        formState: { ...state.formState, tabState: merged as FormState["tabState"] },
      };
    }
    default:
      return state;
  }
}
